import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import LoadingArea from '@molecules/LoadingArea';
import ArticleCard from '@molecules/ArticleCard';
import ArticleListItemBase from '@molecules/ArticleListItem';

// Functionality
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import { SAVED_ARTICLES_QUERY } from '@general/graphql/article.graph';
import { mapSearchArticleToProps } from '@general/transforms/article.transform';
import useSavedArticles from '@hooks/favorites/useSavedArticles';

const ArticleListItem = props => (
    <div className="mb-1.5rem">
        <ArticleListItemBase {...props} />
    </div>
);

const SearchArticlesSaved = ({
    additionalFilters,
    defaultViewType,
    hitsPerPage,
    parentView,
    showFilters = false,
    showPagingToolbar = false,
    showSearchBox = false,
    showSearchOptions = false,
    updateSearchStateUrl = false,
    NoResultsText,
}) => {
    const [filters, setFilters] = useState('');
    const { data: savedArticles } = useSavedArticles();

    useEffect(() => {
        if (!savedArticles) {
            return;
        }

        setFilters(
            savedArticles.length === 0
                ? 'objectID:NOT-AN-ARTICLE'
                : `(${savedArticles.map(c => `objectID:article-${c.recordId}`).join(' OR ')})`
        );
    }, [savedArticles]);

    if (filters.length === 0) {
        return <LoadingArea />;
    }

    return (
        <SearchModeContext.Provider value={{ showFilters }}>
            <Search
                filters={filters + (additionalFilters ? ` AND ${additionalFilters}` : '')}
                hitsPerPage={hitsPerPage}
                index="articles"
                defaultViewType={defaultViewType}
                displayPagingToolbar={showPagingToolbar}
                displaySearchBox={showSearchBox}
                displaySearchOptions={showSearchOptions}
                updateSearchStateUrl={updateSearchStateUrl}
            >
                <SearchResults
                    cardComponent={ArticleCard}
                    listItemComponent={ArticleListItem}
                    index="articles"
                    NoResultsText={NoResultsText}
                    parentView={parentView}
                    parentSubview="Saved Articles"
                    query={SAVED_ARTICLES_QUERY}
                    transformFunc={mapSearchArticleToProps}
                    typePlural="articles"
                    resultsPerRow={3}
                />
            </Search>
        </SearchModeContext.Provider>
    );
};

SearchArticlesSaved.propTypes = {
    additionalFilters: PropTypes.string,
    defaultViewType: PropTypes.string,
    hitsPerPage: PropTypes.number,
    parentView: PropTypes.string,
    showFilters: PropTypes.bool,
    showPagingToolbar: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    updateSearchStateUrl: PropTypes.bool,
    NoResultsText: PropTypes.elementType,
};

export default SearchArticlesSaved;
